import Toast, { ToastProvider, ToastContext } from './Toast';

export default Toast;

export { ToastProvider, ToastContext };
